import React from 'react';
import ReactDOM from 'react-dom/client';
import { init as initAnalytics } from '@voris/analytics';
import './index.css';
import './amplify';
import { Dashboard } from './Dashboard';
import { AuthProvider } from './useAuth';

if (process.env.REACT_APP_VORIS_WRITE_KEY) {
  initAnalytics({
    writeKey: process.env.REACT_APP_VORIS_WRITE_KEY,
    apiUrl: 'https://api.fvoris.com',
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <Dashboard />
    </AuthProvider>
  </React.StrictMode>,
);
